/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from "@material-ui/core/styles/index";

const styles = theme => ({
    root: {
        color: theme.termsColor ? theme.termsColor : 'rgba(0, 0, 0, 0.45)',
        textAlign: 'center',
        letterSpacing: 0.5,
        textTransform: 'uppercase',
        fontSize: '0.7rem',
        margin: 'auto',
    },
});

class Disclaimer extends PureComponent {

    render() {
        const {classes, content} = this.props;
        return (
            <div className={classes.root}>
                {content}
            </div>
        )
    }
}

export default withStyles(styles)(Disclaimer);
